import { createRequestTypes, action } from '../utils/actions';
import { REQUEST, SUCCESS, FAILURE } from '../utils/constants';

export const GET_APP_LOGS = createRequestTypes('GET_APP_LOGS');
export const SET_APP_LOGS_PAGE = 'SET_APP_LOGS_PAGE';
export const SET_APP_LOGS_PAGE_SIZE = 'SET_APP_LOGS_PAGE_SIZE';
export const SET_APP_LOGS_TABLE_FILTER = 'SET_APP_LOGS_TABLE_FILTER';

export const setAppLogsPageSize = (payload) => ({
  type: SET_APP_LOGS_PAGE_SIZE,
  payload,
});

export const setAppLogsPage = (payload) => ({
  type: SET_APP_LOGS_PAGE,
  payload,
});

export const setAppLogsTableFilter = (payload) => ({
  type: SET_APP_LOGS_TABLE_FILTER,
  payload,
});

export const getAppLogs = {
  request: (data) => action(GET_APP_LOGS[REQUEST], { data }),
  success: (payload) => action(GET_APP_LOGS[SUCCESS], { payload }),
  failure: (payload) => action(GET_APP_LOGS[FAILURE], { payload }),
};
